export default __webpack_public_path__ + "static/media/Ballroll_00296.eb44b9b3.png";